// Mirror of build-time MiniSearch config (must stay in sync with
// scripts/build_search_index.mjs).
import MiniSearch from "minisearch";
import { get, set } from "idb-keyval";

const TOKENIZE_PATTERN =
  /[\s.,;:!?()[\]"'\u2013\u2014\u2018\u2019\u201c\u201d]+/;

export function tokenize(text) {
  return String(text)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .split(TOKENIZE_PATTERN)
    .filter(Boolean);
}

const OPTIONS = {
  fields: ["text", "attribution", "book"],
  storeFields: [
    "type",
    "bookSlug",
    "book",
    "chapter",
    "verse",
    "attribution",
    "text",
  ],
  tokenize,
};

const SHARDS = { nt: ['nt'], ot: ['ot-1', 'ot-2', 'ot-3'] };
const cache = { _shards: {}, _promises: {} };

async function loadShard(name) {
  if (cache._shards[name]) return cache._shards[name];
  if (cache._promises[name]) return cache._promises[name];

  cache._promises[name] = (async () => {
    const idbKey = `haydock.search.${name}.v2`;
    let serialised = null;
    try { serialised = await get(idbKey); } catch { /* ignore */ }

    if (!serialised) {
      const res = await fetch(`/search/${name}.json`);
      if (!res.ok) throw new Error(`Failed to load ${name}.json (HTTP ${res.status})`);
      serialised = await res.json();
      try { await set(idbKey, serialised); } catch { /* ignore */ }
    }

    const idx = MiniSearch.loadJS(serialised, OPTIONS);
    cache._shards[name] = idx;
    delete cache._promises[name];
    return idx;
  })();

  return cache._promises[name];
}

export async function getIndex(testament = "both") {
  const names =
    testament === "nt" ? SHARDS.nt :
    testament === "ot" ? SHARDS.ot :
    [...SHARDS.nt, ...SHARDS.ot];
  return Promise.all(names.map(loadShard));
}
